import * as React from 'react';
import withStyles, { WithStyles } from '@material-ui/core/styles/withStyles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Stepper from '@material-ui/core/Stepper';
import Step from '@material-ui/core/Step';
import StepLabel from '@material-ui/core/StepLabel';
import Typography from '@material-ui/core/Typography';
import AddressForm from './AddressForm';
import PaymentForm from './PaymentForm';
import Review from './Review';
import { Theme, createStyles } from '@material-ui/core';
import { defaultView, DefaultView } from '../HOC';
import strings from 'src/strings';
import { Elements } from 'react-stripe-elements';

interface CheckoutProps extends WithStyles<typeof styles>, DefaultView {

}

interface CheckoutState {
    activeStep: number
}
const steps = [strings.checkout_billingAddress, strings.checkout_paymentMethod, strings.checkout_subscribe];
class Checkout extends React.Component<CheckoutProps, CheckoutState> {


    constructor(props: CheckoutProps) {
        super(props)
        let step = 0
        let parsed = new URLSearchParams(this.props.location.search);
        if (parsed.get('step')) {
            step = parseInt(parsed.get('step') as string) || 0
        }
        this.state = {
            activeStep: step
        }
    }

    handleNext = () => {
        this.setState(state => ({
            activeStep: state.activeStep + 1,
        }));
    };

    handleBack = () => {
        this.setState(state => ({
            activeStep: state.activeStep - 1,
        }));
    };

    handleReset = () => {
        this.setState({
            activeStep: 0,
        });
    };

    private cancel = () => {
        this.props.history.push('/app/dashboard')
    }

    getStepContent(step: number) {
        switch (step) {
            default:
            case 0:
                return <AddressForm onCancel={this.cancel} onNext={() => {
                    this.setState({
                        activeStep: 1,
                    })
                    this.props.history.push({
                        pathname: this.props.location.pathname,
                        search: 'step=1',
                        state: this.props.location.state
                    })
                }} />;
            case 1:
                return <Elements><PaymentForm onCancel={this.cancel} onNext={() => {
                    this.setState({
                        activeStep: 2,
                    })
                    this.props.history.push({
                        pathname: this.props.location.pathname,
                        search: 'step=2',
                        state: this.props.location.state
                    })
                }} onBack={() => {
                    this.setState({
                        activeStep: 0,
                    })
                    this.props.history.push({
                        pathname: this.props.location.pathname,
                        search: 'step=0',
                        state: this.props.location.state
                    })
                }} />
                </Elements>
                    ;
            case 2:
                return <Review onCancel={this.cancel} onNext={() => {
                    sessionStorage.setItem('subscribed', 'true')
                    this.props.history.push({
                        pathname: '/app/dashboard'
                    })
                }} onBack={() => {
                    this.setState({
                        activeStep: 1,
                    })
                    this.props.history.push({
                        pathname: this.props.location.pathname,
                        search: 'step=1',
                        state: this.props.location.state
                    })
                }} />;
        }
    }

    public render() {
        const { classes } = this.props;
        const { activeStep } = this.state;

        return (
            <React.Fragment>
                <CssBaseline />
                <main className={classes.layout}>
                    <Paper className={classes.paper}>
                        <Typography component="h1" variant="h4" align="center">
                            {strings.checkout}
                        </Typography>
                        <Stepper activeStep={activeStep} className={classes.stepper}>
                            {steps.map(label => (
                                <Step key={label}>
                                    <StepLabel>{label}</StepLabel>
                                </Step>
                            ))}
                        </Stepper>
                        <React.Fragment>
                            {this.getStepContent(activeStep)}
                        </React.Fragment>
                    </Paper>
                </main>
            </React.Fragment>
        )
    }
}

const styles = (theme: Theme) => createStyles({
    appBar: {
        position: 'relative',
    },
    layout: {
        width: 'auto',
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
            width: 600,
            marginLeft: 'auto',
            marginRight: 'auto',
        },
    },
    paper: {
        marginTop: theme.spacing(3),
        marginBottom: theme.spacing(3),
        padding: theme.spacing(2),
        [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
            marginTop: theme.spacing(6),
            marginBottom: theme.spacing(6),
            padding: theme.spacing(3),
        },
    },
    stepper: {
        padding: `${theme.spacing(3)}px 0 ${theme.spacing(5)}px`,
    },
    buttons: {
        display: 'flex',
        justifyContent: 'flex-end',
    },
    button: {
        marginTop: theme.spacing(3),
        marginLeft: theme.spacing(),
    },
});

export default defaultView(withStyles(styles)(Checkout), true) as React.ComponentClass;


// WEBPACK FOOTER //
// ./src/components/Checkout/Checkout.tsx